<p-toast key="risk-config-list" position="top-right"></p-toast>
<p-confirmDialog key="risk-config-list" styleClass="risk-config-confirm"></p-confirmDialog>

<p-card styleClass="risk-config-card">
  <div class="page-header">
    <div class="header-left">
      <span class="page-icon is-primary"><i class="fa-solid fa-gauge-high" aria-hidden="true"></i></span>
      <div>
        <h1>Calculadora de riesgo</h1>
        <p class="header-subtitle">
          Pesos, umbrales, bandas y vetos con los que se califica a cada cliente. Cada cambio es una versión nueva.
        </p>
      </div>
    </div>
    <div class="header-right">
      <a
        *ngIf="canCreate"
        pButton
        class="p-button-sm"
        icon="pi pi-plus"
        label="Nueva versión"
        routerLink="/risk-scorecard-config/new"
        data-test="config-new"
      ></a>
    </div>
  </div>

  <p-divider></p-divider>

  <div class="active-box" *ngIf="active as current" data-test="config-active">
    <div class="active-main">
      <span class="eyebrow">En uso</span>
      <h2>v{{ current.version }} · {{ current.name }}</h2>
      <p class="muted">
        Activada por {{ authorOf(current) }} el {{ dateOf(current) | mxDate
        }}<ng-container *ngIf="activeReason"> · «{{ activeReason }}»</ng-container>
      </p>
    </div>
    <p class="note" *ngIf="current.isSystemDefault" data-test="config-seed-note">
      <i class="pi pi-info-circle" aria-hidden="true"></i>
      Son los umbrales que propuso el equipo. Mientras Finanzas no active una versión propia, la calculadora muestra «Umbrales en validación
      por Finanzas».
    </p>
  </div>

  <div class="empty-state" *ngIf="loading" data-test="config-loading">
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
    <span>Cargando versiones…</span>
  </div>

  <div class="empty-state is-error" *ngIf="!loading && loadError" role="alert" data-test="config-error">
    <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
    <h3>No pudimos cargar las versiones</h3>
    <span>{{ loadError }}</span>
    <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-refresh" label="Reintentar" (click)="load()"></button>
  </div>

  <div class="table-wrap" *ngIf="!loading && !loadError && versions.length">
    <table class="config-table">
      <caption class="p-hidden-accessible">
        Versiones de la configuración de la calculadora de riesgo
      </caption>
      <thead>
        <tr>
          <th scope="col">Versión</th>
          <th scope="col">Nombre</th>
          <th scope="col">Estado</th>
          <th scope="col">Motivo</th>
          <th scope="col">Responsable</th>
          <th scope="col"><span class="p-hidden-accessible">Acciones</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let version of versions; trackBy: trackById" data-test="config-row">
          <td class="version">
            v{{ version.version }}
            <i
              *ngIf="version.isSystemDefault"
              class="pi pi-lock"
              pTooltip="Semilla del sistema: no se edita ni se borra"
              aria-label="Semilla del sistema"
            ></i>
          </td>
          <td>
            <span class="name">{{ version.name }}</span>
            <span class="muted" *ngIf="version.derivedFromVersion">derivada de v{{ version.derivedFromVersion }}</span>
          </td>
          <td><p-tag [severity]="statusUi[version.status].severity" [value]="statusUi[version.status].label"></p-tag></td>
          <td class="reason">{{ version.changeReason }}</td>
          <td>
            <span>{{ authorOf(version) }}</span>
            <span class="muted">{{ dateOf(version) | mxDate }}</span>
          </td>
          <td class="row-actions">
            <a
              pButton
              class="p-button-text p-button-sm"
              [icon]="version.status === 'draft' ? 'pi pi-pencil' : 'pi pi-eye'"
              [label]="version.status === 'draft' ? 'Editar' : 'Ver'"
              [routerLink]="['/risk-scorecard-config', version._id]"
              data-test="config-open"
            ></a>
            <button
              *ngIf="canRemove(version)"
              pButton
              type="button"
              class="p-button-text p-button-danger p-button-sm"
              icon="pi pi-trash"
              [attr.aria-label]="'Borrar el borrador v' + version.version"
              (click)="remove(version)"
              data-test="config-remove"
            ></button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</p-card>
